export const SET_PASSPORT = "SET_PASSPORT"
export const CLEAR_PASSPORT = "CLEAR_PASSPORT"